export const COLOR_MAP = {
    PRIMARY: '#C599E5',
    WHITE: '#FFFFFF',
    GREY: '#E7E7EA',
    DARK_GREY: '#444255',
    LIGHT_GREY: '#1D1934',
    LIGHT_GREY2: '#FAFAFB',
    DISABLED: '#F4F4F5',
    GREY_0: '#131120',
    GREY_1: '#A5A3AE',
    GREY_2: '#2B244C',
    GREY_3: '#565365',
    GREY_4: '#AAA7B7',
    GREY_5: '#59566C',
    GREY_6: '#E8E8EB',
    GREY_7: '#59566C',
    GREY_8: '#FAFBFC',
    GREY_9: '#F6F6F7',
    GREY_10: ' #17142A',
    LIGHT_PURPLE: '#F7F2FA',
    BORDER_GREY: "#D2D1D6",
    PILL_BORDER: "#E6EBEF",
    PILL_Bk: '#F0F1FA',
    DARK_PURPLE: '#6E00BE',
    LAVENDER_GREY: '#BABDDB',
    WARNING: '#FFF6E5',
    WARNING_BOLD: '#FFA000',
    LIGHT_BLUE: '#C0D1E2',
    GREY_DARK: "#777584",
    GREEN: "#78B856",
    GREEN_LIGHT: '#9ACA80',
    GREEN_DARK: '#228568',
    WHATS_APP_GREEN: '#2BA682',
    ERROR: '#ff0000',
    LAVENDER_PRIMARY: "#F0E4F8",
    SECONDARY_GREEN: '#E1EDD7',
    CAPE_HONEY: '#FEDEA4',
    WARNING_YELLOW: '#FFF6E5',
    FAILURE: '#ff0000',
    FAILURE_BACKGROUND: '#FCEBE9',
    FAILURE_BORDER: '#E0392333',
    WHITE_BACKGROUND: '#FCFAFE',
    BLACK: ' #000000',
    BLACK_2: '#353535',
    BUTTON_DISABLED: '#00000042',
    ALICE_BLUE: '#F3F9FF',
    ALICE_BLUE_2: '#EAF4FF',
    COLUMBIA_BLUE: '#AED5FF',
    WARNING_BOX: '#FFA000',
    NOTIFICATION_BOX: '#D5EDE6',
    LIGHT_PURPLE2: '#F1E6F9',
    LIGHT_PINK: '#F9D7D3',
}